module.exports = __webpack_public_path__ + "static/media/1 43 aldri.63cdb40c.mp3";